export default "__VITE_ASSET__12c0fc68__"